'use client';

import React from 'react';
import { useTranslation } from 'react-i18next';

import { ConversionTimingMetrics } from './ConversionTimingMetrics';
import { useCheckoutToEmailEnteredTimeData } from '@/lib/api/analytics';
import { useStatsFilters } from '../context/StatsFiltersContext';

interface CheckoutToEmailEnteredTimeProps {
    className?: string;
}

export function CheckoutToEmailEnteredTime({ className = '' }: CheckoutToEmailEnteredTimeProps) {
    const { t } = useTranslation('analytics');
    const { selectedDates, selectedStores, selectedCurrency } = useStatsFilters();

    const { data, isLoading, error } = useCheckoutToEmailEnteredTimeData(
        {
            startDate: selectedDates.from!,
            endDate: selectedDates.to!,
            storeIds: selectedStores,
            currency: selectedCurrency,
        },
        {
            enabled: !!(selectedDates.from && selectedDates.to),
        }
    );

    return (
        <ConversionTimingMetrics
            title={t('conversion.timing.checkoutToEmail.title')}
            description={t('conversion.timing.checkoutToEmail.description')}
            data={data}
            isLoading={isLoading}
            error={error}
        />
    );
}
